import axios from 'axios';

class SoundsTags {
    tag(soundId, tag) {
        return new Promise((resolve, reject) => {
            axios.post('/tagSoundEasy/' + soundId + '/' + tag)
                .then((ret) => resolve())
                .catch(err => reject(err));
        });
    }

    getTags(soundId) {
    }
}

export default SoundsTags;
